import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSettlement } from '../../../api/paymentsApi/settlementsApi';
import { Box, CircularProgress } from '@mui/material';

const SettlementInitialRoute = () => {
  const { settlementId } = useParams();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    if (!settlementId) {
      return;
    }

    getSettlement(Number(settlementId))
      .then((res) => {
        if (res.status === 200) {
          // Check condition and decide where to route
          if (res.data.status !== 'Draft' && res.data.withheld === false) {
            navigate(`/payments/settlement/${settlementId}/details`, { replace: true });
          } else {
            navigate(`/payments/settlement/${settlementId}/home`, { replace: true });
          }
        }
      })
      .catch((error) => {
        console.error('Settlement Initial Route - Error:', error);
        // On error, default to home page
        navigate(`/payments/settlement/${settlementId}/home`, { replace: true });
      })
      .finally(() => {
        setIsChecking(false);
      });
  }, [settlementId, navigate]);

  if (isChecking) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="400px">
        <CircularProgress />
      </Box>
    );
  }

  return null;
};

export default SettlementInitialRoute;